export default "__VITE_ASSET__BPWvd3oz__"